/**
 * Mapeia as alternativas de uma question (estrutura de dados
 * da API e consequentemente, da store) para a estrutura de dados
 * interpretada pelo componente de seção..
 */
function mapAlternativasToItemData(alternativas) {
  return alternativas.map((alternativa) => ({
    value: alternativa.id,
    label: alternativa.enunciado,
  }));
}

/**
 * converte as questions (estrutura de dados da store)
 * para uma estrutura de dados que será interpretada
 * pelo componente de seção.
 *
 * @param {*} questions
 */
function adaptQuestionsToData(questions, selectedIds) {
  const questionsData = questions.map((question) => ({
    value: question.id,
    label: question.enunciado,
    checked: selectedIds ? selectedIds.includes(question.id) : false,
    isDataLoading: question.running ? question.running : false,
    data: question.alternativas
      ? mapAlternativasToItemData(question.alternativas)
      : [],
  }));
  return questionsData;
}

export { adaptQuestionsToData };
